export const basicText2023Gql = /* GraphQL */`... on landingPageContent2023_basicText_BlockType {
  typeHandle
  basicTextEyebrow
  basicTextTitle
  description: landingPageBasicTextDescription
  textAlignment
  textBlocks:textBlocksLP2 {
    ... on textBlocksLP2_BlockType {
      eyebrow
      subheader
      text
      textAlignment
      custom
      buttonLabel
      ariaLabel
      openInANewWindow
      primaryCtaBtn {
        ariaLabel
        customText
        target
        text
        title
        type
        url
      }
      primaryCtaBtnLabel
      primaryCtaBtnAriaLabel
      primaryCtaBtnTheme
      primaryCtaBtnOpenInANewWindow
      secondaryButtonTheme
      entry {
        url
        title
      }
      asset {
        url
      }
      productCategory {
        url
      }
    }
  }
  buttons {
    buttonUrl
    buttonLabel
    openInANewTab
    buttonTheme
  }
  columns
  colors
}`;
